var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMktgCheckShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 67"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCC6D2",
    d: "M35.24 66.49A28.28 28.28 0 017 38.24 28.28 28.28 0 0135.24 10 28.28 28.28 0 0163.5 38.24 28.28 28.28 0 0135.24 66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M31 0c17.1 0 31 13.9 31 31S48.1 62 31 62 0 48.1 0 31 13.9 0 31 0zm0 59.24A28.28 28.28 0 0059.24 31 28.28 28.28 0 0031 2.76 28.28 28.28 0 002.76 31 28.28 28.28 0 0031 59.24zm15.76-36.02l-3.9-3.46-17.93 15.93-7.8-6.92-3.9 3.46 11.7 10.39 21.83-19.4z"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-mktg--check-shadow-b6b185074e2a181ecf9a2c0c89ff1e7d.svg";
export { SvgIconMktgCheckShadow as Component };